import { render } from "./user-messages.vue?vue&type=template&id=7e6dcd86"
import script from "./user-messages.vue?vue&type=script&lang=js"
export * from "./user-messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__